import { AreaWithNestedJsonInfo, IFetchMapSuccess, IMapState } from 'types/map';
import Area from 'mapping/Area';

export default function fetchMapSuccess(state: IMapState, { payload }: IFetchMapSuccess) {
  const { currentArea, areas } = payload;
  const flattenedAreas = flattenAreas(areas)
    .map(area => ({ ...area, ...area.jsonInfo }))
    .map(a => new Area(a).toStateAwareArea(areas, currentArea));
  return {
    ...state,
    currentArea: { ...currentArea, ...(currentArea.jsonInfo ?? {})}, // currentArea needs jsonInfo too
    areas: flattenedAreas,
    isFetching: false,
    shouldUpdate: false,
  };
}

function flattenAreas(areas: AreaWithNestedJsonInfo[]): AreaWithNestedJsonInfo[] {
  return areas.flatMap(a => {
    if (a.childAreas && a.childAreas.length) {
      return [a, ...flattenAreas(a.childAreas)];
    }
    return [a];
  });
}
